import { render, staticRenderFns } from "./ToTopButton.vue?vue&type=template&id=5480d8d0&"
import script from "./ToTopButton.vue?vue&type=script&lang=js&"
export * from "./ToTopButton.vue?vue&type=script&lang=js&"
import style0 from "./ToTopButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports